import { render, staticRenderFns } from "./DataBindingTest.vue?vue&type=template&id=435e565c&"
import script from "./DataBindingTest.vue?vue&type=script&lang=js&"
export * from "./DataBindingTest.vue?vue&type=script&lang=js&"
import style0 from "./DataBindingTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports